import api from "@/api";
import { ref } from "vue";
import { useStore } from "@/store";
const store = useStore();
import { GeneralActionTypes } from "@/store/modules/general/action-types";
const activeRowModal: any = ref({});
const addDesicion: any = ref({});
import { notify } from "@kyvg/vue3-notification";
import $ from "jquery";
import { Roles } from "../enums/Roles";

const data = {
  readyToUseFilters: {},
  filter: {
    hideFilter: false,
    searchResult: true,
    ignoreSaveFilter: true,
    searchText: true,
    title: "Review Filter",
    pageName: "ProposedUniqueBlockPage",
    genre: "proposedUniqueBlock",
    filters: [
      {
        title: "rolePolicy",
        apiEquivalent: "rolePolicy",
        type: "select",
        param: "label",
        hideOnRole: Roles.GroupAdmin,
        data: [
          {
            label: "WorkStation",
            id: "WorkStation",
          },
          {
            label: "Basic Server",
            id: "Basic Server",
          },
          {
            label: "Server Lock Down",
            id: "Server Lock Down",
          },
        ],
      },
      {
        title: "mode",
        apiEquivalent: "mode",
        type: "select",
        param: "label",
        vmodel: null,
        data: [
          {
            label: "Enforcing",
            id: "1",
          },
          {
            label: "Discovery",
            id: "2",
          },
        ],
      },
      {
        title: "action",
        apiEquivalent: "action",
        type: "select",
        param: "label",
        vmodel: null,
        data: [
          {
            label: "Blocked Process",
            id: "Blocked Process",
          },
          {
            label: "Blocked File",
            id: "Blocked File",
          },
          {
            label: "Blocked Registry",
            id: "Blocked Registry",
          },
          {
            label: "Blocked Code Load",
            id: "Blocked Code Load",
          },
          {
            label: "Blocked Memory",
            id: "Blocked Memory",
          },
        ],
      },
      {
        title: "status",
        type: "select",
        apiEquivalent: "status",
        vmodel: null,
        param: "label",
        disabled: false,
        data: [
          {
            label: "Not Decided",
            id: "0",
          },
          {
            label: "Decision Drafted",
            id: "1",
          },
          {
            label: "Decision Applied",
            id: "2",
          },
          {
            label: "Decision Published",
            id: "3",
          },
        ],
      },
      {
        title: "decision",
        apiEquivalent: "decision",
        type: "select",
        param: "label",
        vmodel: null,
        disabled: false,
        data: [
          {
            label: "Modify Policy",
            id: "1",
          },
          {
            label: "Keep Enforcing",
            id: "2",
          },
        ],
      },
      {
        title: "Time Range",
        type: "date",
        param: "range",
        apiEquivalent: "range",
        hidden: true,
        vmodel: null,
      },
      {
        title: "Actor",
        apiEquivalent: "actor",
        type: "wordstyped",
        param: "actor",
        disabled: true,
      },
      {
        title: "Target",
        apiEquivalent: "target",
        type: "wordstyped",
        param: "target",
        disabled: true,
      },
    ],
  },
  models: {
    addDescion: {
      id: "",
      eventId: "",
      rolePolicy: "",
      uniqueEventHash: "",
      mode: "",
      action: "",
      actor: "",
      target: "",
      effectedComputerCount: "",
      totalComputerCount: "",
      eventCount: "",
      percentageComputer: "",
      policyFileVersion: "",
      lastStatusChange: "",
      groupGuid: "",
      decision: "",
      option: "",
      decisionStatusId: "",
      decisionOptionId: "",
      decisionId: "",
      decisionStatus: "",
      scope: "",
    },
  },
  header: {
    policyNavigation: true,
  },
  component: {
    type: "ag-table",
    decisionId: 0,
    decisionStatusId: 0,
    compKey: 0,
    options: {
      columns: [
        {
          label: "mode",
          field: "modeName",
          sortable: false,
        },
        {
          label: "action",
          field: "action",
          sortable: true,
          display: function (row: any) {
            let label = "";
            if (row.action.indexOf("Allow") > -1) {
              label = '<span class="green-indicator"></span>';
            } else {
              label = '<span class="red-indicator"></span>';
            }
            return (
              "<div class='d-flex align-items-center'> " +
              label +
              " <span>" +
              row.action.replaceAll("Blocked", "").replaceAll("Allowed", "") +
              "</span> </div>"
            );
          },
        },
        {
          label: "actor",
          field: "actor",
          sortable: true,
          truncate: {
            position: "middle",
            first: 6,
            last: 6,
          },
        },
        {
          label: "target",
          field: "target",
          sortable: true,
          truncate: {
            position: "middle",
            first: 6,
            last: 6,
          },
        },
        {
          label: "effectedTotalComp",
          field: "effectedTotalComp",
          sortable: false,
          display: function (row: any) {
            let labelClass = "warning";
            if (row.percentageComputer < 50) {
              labelClass = "success";
            } else if (
              row.percentageComputer > 50 &&
              row.percentageComputer < 70
            ) {
              labelClass = "warning";
            } else {
              labelClass = "danger";
            }
            return `<div class="d-flex align-items-center">${row.effectedComputerCount} / ${row.totalComputerCount} <span class="ag-badge badge badge-${labelClass}">${row.percentageComputer} %</span></div>`;
          },
        },
        {
          label: "eventcount",
          onclick: (row: any) => {
            store.dispatch(GeneralActionTypes.SET_SELECTED_ROW, row);
            store.dispatch(
              GeneralActionTypes.SET_COMPKEY,
              store.getters.compKey + 1
            );
          },
          display: function (row: any) {
            if (row.eventCount) {
              return `<a
              data-toggle="modal"
              data-target="#exampleModalCenterSecondary"
              href="#"
              class="name-btn"
              >${row.eventCount}</a
            >`;
            } else {
              return 0;
            }
          },
        },
        {
          label: "decisionOption",
          field: "decisionOptionName",
          hidden: function (prt: any) {
            return prt.$route.fullPath.indexOf("keep-enforcing") > -1;
          },
          sortable: false,
        },
        {
          label: "lastStatusChange",
          sortable: false,
          components: [
            {
              component: "tableDateFormatter",
              field: "lastStatusChange",
            },
          ],
        },
        //  hidden: function (prt: any) {
        //     return prt.$route.params.param !== "SummaryEvents";
        //   },

        {
          label: "",
          field: "apply",
          hidden: function (prt: any) {
            return prt.$route.fullPath.indexOf("drafted") === -1;
          },
          components: [
            {
              component: "rowCustomRouter",
              key: "id",
              route: function (row: any) {
                let mainId = 0;
                try {
                  const agmsGroupString: any =
                    localStorage.getItem("agms_group");
                  const agmsGroup: any = JSON.parse(agmsGroupString);
                  mainId = agmsGroup.mainid;
                } catch (error) {
                  console.log(error);
                }
                return `/administration/policy-tuning?mainId=${mainId}&decisionStatusId=${row.decisionStatusId}&rowId=${row.id}`;
              },
            },
          ],
        },
        {
          label: "",
          field: "edit",
          width: "100px",
          hidden: function (prt: any) {
            return prt.$route.fullPath.indexOf("drafted") === -1;
          },
          display: function (row: any) {
            row.notEditable = true;
            addDesicion.value.data = row;
          },
          components: [
            {
              component: "tableExpandComponent",
            },
          ],
        },
        {
          label: "",
          field: "show",
          width: "100px",
          hidden: function (prt: any) {
            return prt.$route.fullPath.indexOf("drafted") > -1;
          },
          display: function (row: any) {
            row.notEditable = false;
            addDesicion.value.data = row;
          },
          components: [
            {
              component: "tableShowComponent",
            },
          ],
        },
        {
          label: "",
          field: "delete",
          width: "100px",
          hidden: function (prt: any) {
            return prt.$route.fullPath.indexOf("drafted") === -1;
          },
          components: [
            {
              component: "tableDeleteComponent",
              class: "mr-2 ml-2 mt-2",
              idField: "id",
            },
          ],
        },
      ],
      dateFilter: false,
      rows: [],
      total: 0,
      sortable: {
        order: "",
        sort: "asc",
      },
      page: 1,
      pageSize: 10,
      isLoading: false,
     fetchTable: async (options: any) => {
  const filters = data.readyToUseFilters;
  const body: any = { filters, options };

  if (options.currentSearchFilters) {
    body.filters = { 
      ...options.currentSearchFilters, 
      page: options.page, 
      limit: options.pageSize 
    };
  }

  if (options.isSearchMode) {
    delete body.filters.decisionId;
    delete body.filters.decisionStatusId;
    store.dispatch(GeneralActionTypes.GET_PROPOSED_UNIQUE_BLOCKS, body);
  } else {
    store.dispatch(GeneralActionTypes.GET_REVIEW_CHECK_LIST, body);
  }
},
    },
  },
  modals: [
    {
      id: "exampleModalCenter",
      hideAction: function (prt: any) {
        return prt?.$route?.fullPath.indexOf("drafted") === -1;
      },
      action: {
        label: "Save",
        function: async function (arg: any) {
          const body = {
            id: data.models.addDescion.id,
            decisionStatusId: data.models.addDescion.decisionStatusId,
            decisionOptionId: data.models.addDescion.decisionOptionId,
            option: data.models.addDescion.option,
            decisionId: data.models.addDescion.decisionId,
            scope: data.models.addDescion.scope,
          };
          await store.dispatch(
            GeneralActionTypes.UPDATE_REVIEW_CHECKLIST_ITEM,
            body
          );
          $($("#exampleModalCenter")[0]).removeClass("show");
          $($("#exampleModalCenter")[0]).css("display", "none");
          $("body").removeClass("modal-open");
          $(".modal-backdrop").remove();
          notify({
            title: "Saved",
            type: "success",
            duration: 4000,
          });
          store.dispatch(
            GeneralActionTypes.SET_COMPKEY,
            store.getters.compKey + 1
          );
        },
      },
      display: function (row: any) {
        activeRowModal.value.data = row;
      },
      cancel: {
        label: "Close",
      },
      active: 0,
      items: [
        {
          title: "editDesicion",
          component: "ag-add-desicion",
          options: { activeRowModal, addDesicion },
        },
      ],
    },
    {
      id: "exampleModalCenterSecondary",
      action: {
        label: "Save",
        function: function (arg: any) {
          alert(JSON.stringify(arg));
        },
      },
      cancel: {
        label: "Close",
      },
      items: [
        {
          title: "individualEvents",
          component: "ag-event-list",
          options: {},
          filters: () => {
            return data.readyToUseFilters;
          },
        },
        {
          title: "overallview",
          component: "ag-overall",
        },
        {
          title: "processtree",
          component: "ag-processtree",
        },
        {
          title: "computer",
          component: "ag-computer",
        },
        {
          title: "hashdetails",
          component: "ag-hashdetail",
        },
        {
          title: "hashxmldetail",
          component: "ag-hashxmldetail",
        },
      ],
    },
  ],
};

export default data;
